// Cognito auth config - values will be populated after CDK deploy
// For DevSpace testing, set REACT_APP_AUTH_DISABLED=true to bypass auth
const AUTH_DISABLED = process.env.REACT_APP_AUTH_DISABLED === 'true' || window.location.hostname.includes('proxy.devspaces');

const config = {
  userPoolId: 'us-west-2_htr0JrI9z',
  region: 'us-west-2',
  // These will be set after CDK deploys the Cognito stack
  clientId: '2vhkudsms54c3on8mfnqhalvoi',
  domain: 'federate-jarjar-beta.auth.us-west-2.amazoncognito.com',
  redirectUri: window.location.origin,
  logoutUri: window.location.origin,
};

function getLoginUrl() {
  return `https://${config.domain}/oauth2/authorize?client_id=${config.clientId}&response_type=code&scope=openid+profile&redirect_uri=${encodeURIComponent(config.redirectUri)}`;
}

function getLogoutUrl() {
  return `https://${config.domain}/logout?client_id=${config.clientId}&logout_uri=${encodeURIComponent(config.logoutUri)}`;
}

function getTokenUrl() {
  return `https://${config.domain}/oauth2/token`;
}

async function exchangeCodeForTokens(code) {
  const response = await fetch(getTokenUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: config.clientId,
      code,
      redirect_uri: config.redirectUri,
    }),
  });
  if (!response.ok) throw new Error('Token exchange failed');
  return response.json();
}

function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch { return null; }
}

function getStoredTokens() {
  const tokens = sessionStorage.getItem('jarjar_tokens');
  if (!tokens) return null;
  const parsed = JSON.parse(tokens);
  const idPayload = parseJwt(parsed.id_token);
  if (idPayload && idPayload.exp * 1000 < Date.now()) {
    sessionStorage.removeItem('jarjar_tokens');
    return null;
  }
  return parsed;
}

function storeTokens(tokens) {
  sessionStorage.setItem('jarjar_tokens', JSON.stringify(tokens));
}

function getUser() {
  const tokens = getStoredTokens();
  if (!tokens) return null;
  const payload = parseJwt(tokens.id_token);
  if (!payload) return null;
  // Federate logs in as cognito:username = "FederateOIDC_<alias>". Prefer the
  // explicit USER_NAME claim, then the cleaned Federate alias, then email, and
  // only fall back to the opaque sub UUID as a last resort.
  const cognitoUser = payload['cognito:username'] || '';
  const federateAlias = cognitoUser.replace(/^FederateOIDC_/i, '') || '';
  return {
    username: payload['custom:USER_NAME'] || federateAlias || payload.email || payload.sub,
    email: payload.email,
    givenName: payload.given_name,
    familyName: payload.family_name,
  };
}

function logout() {
  sessionStorage.removeItem('jarjar_tokens');
  window.location.href = getLogoutUrl();
}

// Loading-spinner easter eggs. Keeps the shared random set for everyone, and adds
// a per-user egg for drodehea (dak.png at 10%). Reads the alias from the stored
// id token so it works inside inline render expressions (no hook needed).
function loadingImage() {
  let alias = '';
  try {
    const tokens = getStoredTokens();
    if (tokens) {
      const p = parseJwt(tokens.id_token) || {};
      alias = (p['cognito:username'] || '').replace(/^FederateOIDC_/i, '') || p.email || '';
    }
  } catch { /* ignore */ }
  const r = Math.random();
  // Per-user egg: drodehea sees dak 10% of the time (other eggs still apply below).
  if (alias === 'drodehea' && r < 0.10) return '/dak.png';
  return r < 0.025 ? '/alternate1.jpg'
    : r < 0.05 ? '/alternate2.jpg'
    : r < 0.06 ? '/jenbre.jpg'
    : r < 0.065 ? '/echevt.jpg'
    : r < 0.0651 ? '/seang2.jpg'
    : '/jarjar.webp';
}

export {
  AUTH_DISABLED,
  config,
  getLoginUrl,
  getLogoutUrl,
  exchangeCodeForTokens,
  getStoredTokens,
  storeTokens,
  getUser,
  logout,
  parseJwt,
  loadingImage,
};
